export const isMaterializedProcessCompleted = (status: string) => status === 'finalized'
